import { useEffect, useState } from 'react'
import { apiValidateCampaignToken } from '../../services/Campaign'

export const useCampaignValidation = (token) => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!token) {
      setData(null)
      setError(null)
      return
    }

    setIsLoading(true)
    setError(null)

    apiValidateCampaignToken(token)
      .then((res) => {
        if (res.data?.success) {
          setData(res.data)
        } else {
          setError(res.data?.error || { message: 'Token inválido' })
          setData(null)
        }
      })
      .catch((err) => {
        const errorMessage = err.response?.data?.error?.user_message || err.message || 'Error al validar el token'
        setError({ message: errorMessage })
        setData(null)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [token])

  return {
    data,
    isLoading,
    error,
  }
}
